<script lang="ts" setup>
import BaseIcon from '@c/common/Icon.vue';
defineProps({
  /** 是否显示默认头部 */
  header: {
    type: Boolean,
    default: true
  },
  /** 主题 */
  effect: {
    type: String,
    default: 'light'
  },
  /** 是否显示关闭按钮 */
  showCustomClose: {
    type: Boolean,
    default: true
  }
});
</script>

<template>
  <ElDialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
    append-to-body
    class="base-dialog"
    :show-close="false"
    :class="{
      'hide-header': !header,
      'is-dark dark': effect === 'dark',
    }"
  >
    <template #header="{ close }">
      <slot v-if="$slots.header" name="header" />
      <div v-else-if="header" class="flex justify-between">
        <h4
          class="c-[--gray-900] flex items-center text-xl-m"
          :class="{ 'c-[--white]': effect === 'dark' }"
        >
          <slot name="title-prefix" />{{ $attrs.title }}
        </h4>
        <BaseIcon
          v-if="showCustomClose"
          name="close"
          class="ts p-6px c-[--gray-900] cursor-pointer shrink-0 self-start hover:c-[--primary] text-sm-r"
          :class="{ 'c-[--white]': effect === 'dark' }"
          @click="close"
        />
      </div>
    </template>
    <slot />
  </ElDialog>
</template>

<style lang="scss">
.el-overlay-dialog .base-dialog {
  padding: 24px;

  .el-dialog__header {
    display: block;
    padding: 0;
    margin: 0 0 16px;
  }

  .el-dialog__body {
    padding: 0;
  }
}

.el-dialog {
  &.hide-header {
    .el-dialog__header {
      display: none !important;
    }
  }
}
</style>